export interface stateTypes {
    profilePath?:any,
    BreadCrumbPath?:any,
    className?:any,
    academicYear?:any
}

export const ValidationMessage = {
select_class_name:'Please select the Class Name'
}